import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ContactUsWidget from '../../components/public-tools/ContactUsWidget';
import { Typography } from '@mui/material';

export default function ContactUsPage() {
  return (
    <PublicToolLayout title="Contact Us">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Get in Touch
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Have a question about our SEO tools, want to book a consultation, or just want to say hello?
        Fill in the form below and we'll get back to you as soon as possible.
      </Typography>
      <ContactUsWidget />
    </PublicToolLayout>
  );
}
